import {Table, TablePaginationConfig} from 'antd';
import React, {FC} from 'react';
import styled from 'styled-components';
import {PuffLoader} from 'react-spinners';
import {colors} from '../../../../styles';
import {FilterValue, SorterResult, TableCurrentDataSource} from 'antd/es/table/interface';
import {IInvent, IPosition} from '../../../../entities/reports';
import CustomEmpty from '../../../../components/CustomEmpty';
import {textMixin} from '../../../../styles/mixins';

interface Props<T = any> {
	data: T[];
	loading: boolean;
	columns: any;
	setFilteredData?: (data: T[]) => void;
	filteredData?: T[];
}

export const TableWrapper: FC<Props> = ({data, loading, columns, setFilteredData}) => {
	const handleChange = (
		pagination: TablePaginationConfig,
		filters: Record<string, FilterValue | null>,
		sorter: SorterResult<IPosition & IInvent> | SorterResult<IPosition & IInvent>[],
		extra: TableCurrentDataSource<IPosition & IInvent>,
	) => {
		setFilteredData?.(extra.currentDataSource);
	};

	const currentData = data && 'error' in data ? [] : (data as (IPosition & IInvent)[]);

	return data ? (
		<Wrapper>
			<Table
				size='small'
				columns={columns}
				dataSource={currentData}
				loading={{
					indicator: <PuffLoader color={colors.loader} />,
					spinning: loading,
				}}
				scroll={{y: 'calc(90vh - 300px)'}}
				pagination={false}
				onChange={handleChange}
				rowKey={(item, i) => {
					return `${item.ID}${item.CATCODE}-${item.CATID}-${i}`;
				}}
				onRow={() => ({
					onClick: () => null,
				})}
				locale={{emptyText: <CustomEmpty />}}
			/>
		</Wrapper>
	) : (
		<PuffLoader />
	);
};

const Wrapper = styled.div`
	${textMixin({
		fontSize: '15px',
		fontWeight: 600,
	})};
	line-height: 26px;
	letter-spacing: 0.02em;
	color: #1f1e24;
	overflow-y: hidden;
	max-height: calc(100vh - 64px);
	border-radius: 4px 4px 0px 0px !important;
`;
